import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="text-3xl font-semibold">Terms of Service</h1>
        <p className="mt-2 text-sm text-slate-600">Last updated: February 26, 2026</p>

        <div className="mt-8 space-y-6 text-sm leading-7 text-slate-700">
          <section>
            <h2 className="text-lg font-semibold text-slate-900">1. Service Scope</h2>
            <p>
              MigraMarket provides social media management tools, analytics, and integrations for authorized business
              accounts.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">2. Account Authorization</h2>
            <p>
              You may connect third-party platforms only if you are authorized to act on behalf of the connected
              account. You are responsible for maintaining valid permissions and complying with each platform policy.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">3. Acceptable Use</h2>
            <p>
              You agree not to use the service for unlawful activity, spam, abusive content, or unauthorized data
              access. We may suspend or terminate access for policy violations.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">4. Third-Party Platforms</h2>
            <p>
              Integrations depend on external APIs and policies from providers such as Meta, X, LinkedIn, TikTok, and
              Google. Availability and features may change without notice from those providers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">5. Liability</h2>
            <p>
              The service is provided on an as-is basis. To the maximum extent permitted by law, MigraTeck disclaims
              implied warranties and limits liability for indirect or consequential damages.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">6. Contact</h2>
            <p>
              For legal or support inquiries, contact us at{" "}
              <a className="text-blue-600 underline" href="mailto:support@migrahosting.com">
                support@migrahosting.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-10 border-t border-slate-200 pt-6 text-sm">
          <Link to="/login" className="text-blue-600 underline">
            Back to Login
          </Link>
        </div>
      </div>
    </main>
  );
}
